import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/AuthContext";
import { CheckCircle2, XCircle } from "lucide-react";

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("verifying");
  useEffect(() => {
    const token = params.get("token");
    if (!token) { setStatus("error"); return; }
    axios.get(`${API}/auth/verify-email?token=${token}`).then(() => setStatus("ok")).catch(() => setStatus("error"));
  }, [params]);
  return (
    <div className="max-w-md mx-auto text-center px-4 py-20 fade-in">
      {status === "ok" ? <><CheckCircle2 className="h-16 w-16 text-emerald-500 mx-auto" /><h1 className="text-2xl font-bold mt-4">Email təsdiqləndi</h1><Link to="/dashboard" className="mt-4 inline-block text-blue-600 font-semibold">İdarəetməyə keç →</Link></> :
       status === "error" ? <><XCircle className="h-16 w-16 text-red-500 mx-auto" /><h1 className="text-2xl font-bold mt-4">Yanlış və ya vaxtı keçmiş token</h1></> :
       <div className="animate-pulse">Yoxlanılır...</div>}
    </div>
  );
}
